module.exports = __webpack_public_path__ + "img/img2.bde4015a.jpg";